<style>
</style>

<template>
  <Modal
    modalName="userAttributesModal"
    title="Atrybuty użytkownika"
    @closed="closed"
    @add='addAttribute'
    :buttons="['addDissabled']"
  >
    <v-layout
      wrap
      align-center
    >
      <v-flex
        xs12
        d-flex
        class="modalSelect__layout"
        id="modalSelect__content"
      >
        <v-select
          :items="layers"
          item-text="name"
          label="Wybierz warstwę"
          attach="#modalSelect__content"
          @change="showAttributes"
          :return-object="true"
          v-model='selected'
        >
        </v-select>
      </v-flex>
    </v-layout>
    <v-layout>
      <div class="list__container list__dict">
        <ul id="values__list">
          <li
            class="list__container--el"
            v-for="(item, index) in chosenLayerAttributes"
            :key="index"
          >
            {{item.display_name}}
            <v-icon
              small
              @click="removeAttribute(index)"
            >fas fa-trash-alt</v-icon>
          </li>
        </ul>
      </div>
    </v-layout>
  </Modal>
</template>

<script>
import Modal from "../../../../shared/Modal";

export default {
  components: {
    Modal
  },
  data: () => ({
    selected: null,
    chosenLayerAttributes: [],
    dialog: false
  }),
  computed: {
    layers() {
      return this.$store.getters.getLayers;
    },
    activeModals() {
      return this.$store.getters.getModalsList;
    }
  },
  methods: {
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    showAttributes() {
      this.chosenLayerAttributes = [];
      this.layers.forEach(layer => {
        if(layer.full_type == this.selected.full_type) {
          layer.fields.forEach(field => {
            if(field.name.slice(0, 7) === "custom_")
              this.chosenLayerAttributes.push(field);
          });
        }
      });
      document
        .querySelector("#btn__modal--addDissabled")
        .classList.remove("v-btn--disabled");
    },
    refreshList() {
      this.chosenLayerAttributes = [];
      this.$store.dispatch("getLayers").then(() => {
        this.layers.forEach(layer => {
          if(layer.full_type == this.selected.full_type) {
            layer.fields.forEach(field => {
              if(field.name.slice(0, 7) === "custom_")
                this.chosenLayerAttributes.push(field);
            });
            this.$root.$emit("updateLayerFields", layer.type, layer.fields);
          }
        });
      });
    },
    removeAttribute(index) {
      let payload = {
        table: this.selected.type,
        field: this.chosenLayerAttributes[index].name
      };
      this.$store.dispatch("removeField", payload).then(() => {
        this.$store.dispatch("getLayers").then(success => {
          if(success) {
            this.$root.$emit(
              "showSnackbar",
              "success",
              "Pomyślnie usunięto kolumnę"
            );
            this.layers.forEach(layer => {
              if(layer.full_type == this.selected.full_type) {
                this.$root.$emit("updateLayerFields", layer.type, layer.fields);
              }
            });
            this.$root.$emit("removedAttribute");
            this.showAttributes();
          } else {
            this.$root.$emit(
              "showSnackbar",
              "red",
              "Podczas usuwania kolumny wystąpił bląd"
            );
          }
        });
      });
    },
    addAttribute() {
      this.$store.commit("setCurrentEditedLayer", this.selected.full_type);
      this.show("addUserAttributesModal");
    },
    closed() {
      this.selected = undefined;
      this.chosenLayerAttributes = [];
    }
  },
  mounted() {
    this.$root.$on("refreshList", this.refreshList);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/settings/modals/userAttributes/UserAttributes.vue